import { useState, useEffect, useCallback } from 'react';

const BASE_HEIGHT = 1080;

export default function useViewportScale() {
  const [factor, setFactor] = useState(() => window.innerHeight / BASE_HEIGHT);

  useEffect(() => {
    const update = () => setFactor(window.innerHeight / BASE_HEIGHT);
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return useCallback((designPx) => Math.round(designPx * factor), [factor]);
}
